
export default {
  name: 'DownloadPDFCardsSection',
  props: {
    blok: {
      type: Object,
      required: true
    }
  }
}
